export const USER_CREATE_REQUEST = 'USER_CREATE_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_ROLE_SET = 'USER_ROLE_SET'
export const USER_UPDATE = 'USER_UPDATE'
export const USER_PROFILE = 'USER_PROFILE'
export const USER_PERMISSION_SET = 'USER_PERMISSION_SET'

export const USER_LIST_REQUEST = 'USER_LIST_REQUEST'
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS'
export const USER_LIST_ERROR = 'USER_LIST_ERROR'
export const USER_LIST_SET = 'USER_LIST_SET'
export const USER_LIST_VOID = 'USER_LIST_VOID'

export const USER_PROFILE_IMG_SET = 'USER_PROFILE_IMG_SET'
export const USER_PROFILE_IMG_GET = 'USER_PROFILE_IMG_GET'
export const USER_PROFILE_IMG_REMOVE = 'USER_PROFILE_IMG_REMOVE'

export const USERS_VIEW_PREFERENCES_REQ = 'USERS_VIEW_PREFERENCES_REQ'
export const SAVE_USERS_VIEW_PREFERENCES = 'SAVE_USERS_VIEW_PREFERENCES'



// WEBPACK FOOTER //
// ./src/store/modules/user/user.type.js